import React, { useContext, useEffect, useRef, useState } from "react";

import ReactECharts from "echarts-for-react";

import { AppSettings } from "../../config/app-settings";
import apiClient from "../../ApiClient";

export default function GenelSiyasiAnketSonuclari() {
  const context = useContext(AppSettings);

  const chartRef = useRef();

  const [chartOption, myChartOption] = useState(null);

  async function fetchData() {
    myChartOption(null);

    try {
      const response = await apiClient.customPost(
        `/query/preview`,
        {
          chart: 1,
          page_id: 23,
          title: "ANKET-GENEL-SIYASET-DIKEY",
          type: "ANKET-GENEL-SIYASET-DIKEY",
          description: "",
          customer: null,
          status: true,
          order: 1,
          connection_type: "local",
          sql: {
            condition: [],
            group: ["TARIH"],
            column: [
              {
                key: "TARIH",
                value: "select",
              },
              {
                key: "PARTI",
                value: "select",
              },
              {
                key: "OY-ORANI",
                value: "select",
              },
            ],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response) {
        const sortedData = [...response].sort(
          (a, b) => a["tarih"].split("/")[0] - b["tarih"].split("/")[0]
        );

        const xAxis = [...new Set(sortedData.map((item) => item["tarih"]))];
        const legend = [...new Set(sortedData.map((item) => item["parti"]))];
        const transformedArray = sortedData.reduce((acc, item) => {
          const existingModel = acc.find(
            (model) => model.name === item["parti"]
          );
          if (existingModel) {
            existingModel.data.push(Number(item["oy-orani"]));
          } else {
            acc.push({
              name: item["parti"],
              data: [Number(item["oy-orani"])],
              type: "line",
              stack: "Total",
              label: {
                show: true,
                position: "top",
              },
              emphasis: {
                focus: "series",
              },
            });
          }
          return acc;
        }, []);

        myChartOption({
          xAxis: xAxis,
          legend: legend,
          series: transformedArray,
        });
      } else {
        myChartOption("none");
      }
    } catch (error) {
      console.error("Genel Data Error", error);
      myChartOption("none");
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return chartOption ? (
    chartOption === "none" ? (
      <span className="d-block text-center">
        {context?.t?.no_data_available}
      </span>
    ) : (
      <div className="flex-1">
        <ReactECharts
          option={{
            darkMode: context?.theme === "light" ? false : true,
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: [
              {
                type: "value",
              },
            ],
            legend: {
              data: chartOption?.legend,
              itemGap: 20,
              textStyle: {
                color: context?.theme === "dark" ? "#fff" : "#000",
              },
            },
            xAxis: [
              {
                type: "category",
                data: chartOption?.xAxis,
                boundaryGap: false,
                axisLabel: {
                  textStyle: {
                    color: context?.theme === "dark" ? "#fff" : "#000",
                  },
                },
              },
            ],
            series: chartOption?.series,
          }}
          ref={chartRef}
          className="w-100 h-100"
        />
      </div>
    )
  ) : (
    <div className="spinner-border text-theme"></div>
  );
}
